package com.neurobs.ccabserver.administrator.view

import com.neurobs.ccab.{SequenceElement, Test, TestRunDetail}
import com.neurobs.ccabserver.administrator.controller.{TestRunDetailInstance, TestStationAdapter}
import com.neurobs.js.dom.{ButtonButton, Grid, GridCell, InputCheckBox, SelectSelectBox, StopWatchElement}
import com.neurobs.js.view._
import com.neurobs.js.dom.ElementFactory
import org.scalajs.dom.raw.HTMLElement
import com.neurobs.js.dom.Grid._
import org.scalajs.dom.html.Div
import scalatags.JsDom.all._

import scala.collection.mutable.ArrayBuffer

class TestStateView {
	import com.neurobs.js.dom.ElementFactory._
	import com.neurobs.js.dom.DOMViewElement._

	private var currentSequence: Option[SequenceElement.Id] = None
	def currentSequenceId: Option[SequenceElement.Id] = currentSequence

	private val panel = new PanelView(title = "", showRefresh = false, fullWidth = true, styles = Some(List(("background", "Cyan"))))

	private val runGrid = new Grid(fullWidth = true, emGapSize = ElementFactory.defaultGridSpacingEm)
	panel.grid.addRow(runGrid.container)

	/* This list is in reverse order to the rows in runGrid */
	private val detailViews = ArrayBuffer[(Div, Option[TestDetailView])]()

	var onCloseClicked: () => Unit = () => Unit

	val container: Container = panel.container

	def update(item: Option[SequenceElement], test: Test, details: Seq[Option[TestRunDetailInstance]], canRun: Boolean, canClose: Boolean, adapter: TestStationAdapter, showComments: Boolean, firstDisplay: Boolean): Unit = {
		//println("TestStateView.update")
		//println(s"showComments = $showComments")
		//for (detail <- details) {
		//	detail match {
		//		case None => println("None")
		//		case Some(d) => println(d)
		//	}
		//}
		//println(s"TestStateView.update firstDisplay: $firstDisplay, item: ${item.map(_.id)}")

		currentSequence = item.map(_.id)

		panel.titleText.setValue(test.name)
		panel.grid.resize(size = 1)

		if (canClose) {
			val closeLink = makeLink(text = "Close")
			closeLink.setHandler(() => onCloseClicked())
			panel.setRightCorner(closeLink)
		}
		else {
			panel.setRightCorner(span().render)
		}

		val runCount = details.length

		if (details.size < detailViews.size) {
			detailViews.reduceToSize(details.size)
			while (runGrid.count > details.size) runGrid.removeRow(rowIndex = 0)
		}
		for (i <- details.view.zipWithIndex) {
			i._1 match {
				case None =>
					if (i._2 < detailViews.size) {
						val div = detailViews(i._2)._1
						div.clear()
						div.appendChild(span("Retrieving run data...").render)
						detailViews(i._2) = (div, None)
					}
					else {
						val d = div(span("Retrieving run data...")).render
						runGrid.insertRow(d, index = 0)
						detailViews += ((d, None))
					}
				case Some(d) =>
					val expand = if (firstDisplay) Some(i._2 == details.size - 1) else None
					val title = s"Run ${i._2 + 1}"
					if (i._2 < detailViews.size) {
						val row = detailViews(i._2)
						row._2 match {
							case Some(view) => view.update(detail = d, title = title, showComments = showComments, expand = expand)
							case None =>
								//println(s"creating detail view for $title, firstDisplay: $firstDisplay, expand: $expand")
								val view = TestDetailView(d, title = title, showComments = showComments, expand = expand.getOrElse(true))
								row._1.clear()
								row._1.appendChild(view.container)
								detailViews(i._2) = (row._1, Some(view))
						}
					}
					else {
						val view = TestDetailView(d, title = title, showComments = showComments, expand = expand.getOrElse(true))
						val row = div(view.container).render
						runGrid.insertRow(row, index = 0)
						detailViews += ((row, Some(view)))
					}
			}
		}

		if (canRun && item.isDefined) {
			val runButton: ButtonButton = makeButton(caption = "Run this test")
			val resetSequenceCheck: InputCheckBox = makeCheckbox()
			val startSelect: SelectSelectBox = makeSelectBox(width = 10)
			val defaultSelection = test.default_start.map(test.starts.indexOf(_))
			startSelect.setOptions(test.starts, defaultSelection)
			if (runCount > 0) { panel.grid.addRow(hr.render) }
			val startSpan =
				if (test.starts.nonEmpty) span(style := "margin-right: 2em", "Start position: ", startSelect.select).render
				else span.render
			panel.grid.addRow(span(startSpan, "Reset sequence position: ", resetSequenceCheck.input).render)
			panel.grid.addRow((runButton.button, Grid.alignCenter))
			runButton.setHandler { () =>
				adapter.runTest(item.get, startSelect.value, resetSequenceCheck.checked)
				if (canClose) { onCloseClicked() }
			}
		}
	}
}